import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FormGroup, InputGroup, Button, AnchorButton, HTMLTable } from "@blueprintjs/core";
import { AxiosInstance } from 'axios';

import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';

import { License, LicenseStatus, SysInfo } from './Types'
import * as utils from "./utils";

import {versionString} from "./App"

declare var isAC3x: boolean;

interface RegisterProps {
    reg: AxiosInstance,
    svc: AxiosInstance,
    licenseStatus?: LicenseStatus,
    onRegister: () => void,
}

function Register({ reg, svc, licenseStatus = {email: "", licenseId: "", type: "", isValidLicense: false} as LicenseStatus, onRegister = () => {} }: RegisterProps) {
    const history = useHistory()
    const { t, i18n } = useTranslation();
    const { register, handleSubmit, reset, setValue } = useForm<License>()
    const [sysinfo, setSysInfo] = useState({} as SysInfo)
    const [changeReg, setChangeReg] = useState(false)

    let defaultEmail = licenseStatus.isValidLicense ? licenseStatus.email : ""
    let defaultLicenseId = licenseStatus.isValidLicense ? licenseStatus.licenseId : ""

    useEffect(() => {
        (async () => {
            try {
                const res = await svc.post('/licensegetsysinfo')
                //console.log("ac3svc", res.data.data)
                //console.log("ac3web", versionString)
                setSysInfo(res.data.data)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [])

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const onSubmit = async (lcn: License) => {
        if (lcn.email && lcn.email.length > 0 && lcn.licenseId && lcn.licenseId.length > 0 && lcn.password && lcn.password.length > 0) {
            lcn = Object.assign(lcn, sysinfo)
            //console.log(lcn)
            try {
                const res = await reg.post('/licenseregister', lcn)
                console.log(res.data)
                await svc.post('/licensesave', res.data)
                utils.showSuccess(t('saved'))
                onRegister()
                history.push("/")
            } catch (error) {
                utils.showError(error)
            }
        } else {
            utils.showError(t('insufficient_data'))
        }
    }

    const onRegisterEdu = async (lcn: License) => {
        if (lcn.email && lcn.email.length > 0 && lcn.password && lcn.password.length > 0) {
            lcn = Object.assign(lcn, sysinfo)
            try {
                const res = await reg.post('/licenseregistereducation', lcn)
                console.log(res.data)
                await svc.post('/licensesave', res.data)
                utils.showSuccess(t('saved'))
                onRegister()
                history.push("/")
            } catch (error) {
                utils.showError(error)
            }
        } else {
            utils.showError(t('insufficient_data'))
        }
    }

    return (
        <>
            {licenseStatus.isValidLicense && <>
                <div style={{fontSize: "21px", fontWeight: 700}}>{t('licensed_to')}</div>
                <div className="Spacing-V-16"></div>
                <div className="Row">
                    <FormGroup className="Col-1-1" label={t('frontend_version')}>
                        <InputGroup readOnly value={versionString} />
                    </FormGroup>
                    <FormGroup className="Col-2-1" label={t('backend_version')}>
                        <InputGroup readOnly value={sysinfo.versionString} />
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-1-2" label={t('user_name')}>
                        <InputGroup readOnly value={licenseStatus.userName} />
                    </FormGroup>
                </div>
                {!isAC3x && <>
                <div className="Row">
                    <FormGroup className="Col-1-2" label={t('email')}>
                        <InputGroup readOnly value={licenseStatus.email} />
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-1-2" label={t('license_id')}>
                        <InputGroup readOnly value={licenseStatus.licenseId} />
                    </FormGroup>
                </div>
                </>}
                <div className="Row">
                    <FormGroup className="Col-1-2" label={t('license_type')}>
                        <InputGroup readOnly value={t(licenseStatus.type)} />
                    </FormGroup>
                </div>
                {licenseStatus.expiryDate && <div className="Row">
                    <FormGroup className="Col-1-2" label={t('expiry_date')}>
                        <InputGroup readOnly value={licenseStatus.expiryDate} />
                    </FormGroup>
                </div>}
                {!(licenseStatus.type === "full") && <div className="Row">
                    <FormGroup className="Col-1-1" label={t('max_env')}>
                        <InputGroup readOnly value={utils.formatNumber(licenseStatus.maxEnv)} />
                    </FormGroup>
                    <FormGroup className="Col-2-1" label={t('max_user')}>
                        <InputGroup readOnly value={utils.formatNumber(licenseStatus.maxUser)} />
                    </FormGroup>
                    {!isAC3x && <FormGroup className="Col-3-1" label={t('max_tx')}>
                        <InputGroup readOnly value={utils.formatNumber(licenseStatus.maxTx)} />
                    </FormGroup>}
                </div>}
                {!isAC3x && <>
                <div className="Spacing-V-16" />
                <div className="Row">
                    <Button className="Col-1-1" icon="edit" onClick={() => {setChangeReg(!changeReg)}}>{t('change')}</Button>
                </div>
                </>}
                <div className="Spacing-V-16"></div>
            </>}
            {!licenseStatus.isValidLicense && <>
                <div style={{fontSize: "21px", fontWeight: 700}}>{t('not_registered')}</div>
                <div className="Spacing-V-16"></div>
                <div className="Row">
                    <FormGroup className="Col-1-1" label={t('frontend_version')}>
                        <InputGroup readOnly value={versionString} />
                    </FormGroup>
                    <FormGroup className="Col-2-1" label={t('backend_version')}>
                        <InputGroup readOnly value={sysinfo.versionString} />
                    </FormGroup>
                </div>
                {!(licenseStatus.type === "full") && <div className="Row">
                    <FormGroup className="Col-1-1" label={t('max_env')}>
                        <InputGroup readOnly value={utils.formatNumber(licenseStatus.maxEnv)} />
                    </FormGroup>
                    <FormGroup className="Col-2-1" label={t('max_user')}>
                        <InputGroup readOnly value={utils.formatNumber(licenseStatus.maxUser)} />
                    </FormGroup>
                    <FormGroup className="Col-3-1" label={t('max_tx')}>
                        <InputGroup readOnly value={utils.formatNumber(licenseStatus.maxTx)} />
                    </FormGroup>
                </div>}
                <div className="Spacing-V-16" />
            </>}

            {(!licenseStatus.isValidLicense || changeReg) && <>
                <div style={{fontSize: "21px", fontWeight: 700}}>{t('register')}</div>
                <div className="Spacing-V-16"></div>
                <form onKeyDown={handleHotkey}>
                    <div className="Row">
                        <FormGroup className="Col-1-2" label={t('email')} labelFor="inputEmail">
                            <InputGroup id="inputEmail" name="email" defaultValue={defaultEmail} inputRef={register} />
                        </FormGroup>
                        <AnchorButton className="Col-3-1 Button-LabeledFormGroup" icon="add" href="#/createemail">{t('create_email')}</AnchorButton>
                    </div>
                    <div className="Row">
                        <FormGroup className="Col-1-1" label={t('password')} labelFor="inputPassword">
                            <InputGroup id="inputPassword" name="password" type="password" inputRef={register} />
                        </FormGroup>
                        </div>
                    <div className="Row">
                        <FormGroup className="Col-1-2" label={t('license_id')} labelFor="inputLicenseId">
                            <InputGroup id="inputLicenseId" name="licenseId" defaultValue={defaultLicenseId} inputRef={register} />
                        </FormGroup>
                        <Button className="Col-3-1 Button-LabeledFormGroup" icon="tick" onClick={handleSubmit(onSubmit)}>{t('register')}</Button>
                    </div>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <Button className="Col-1-2" icon="learning" onClick={handleSubmit(onRegisterEdu)}>{t('register_education')}</Button>
                    </div>
                </form>
            </>}
        </>
    );
}

export default Register